<template>
    <div v-if="!confirmationSent">
        <form action="" id="confirmation-sent-form" @submit.prevent="submitConfirmation" novalidate>
            <div class="as-logo-container"><img :src="logoRougeNoTextSrc" alt="Logo des As de l'info"></div>

            <div class="form-intro" v-html=" store.state.resendMessage ?? '' "></div>


            <div class="centered">
                <button
                    type="button"
                    class="button btn-submit btn-submit-login"
                    ref="btnResendConfirmationSubmit"
                    @click="resendConfirmation">
                    <span class="ajax-loader white centered"></span>    <span v-html=" copydeck?.btnResendConfirmation?.fr ?? '' "></span>
                </button>
            </div>

        </form>

        <div class="register-link-container centered">

            <button type="button" class="text-link link-login link-mode-toggle"
                    @click="changeMode('login')">{{ copydeck?.btnLoginMode?.fr ?? '' }}
            </button>
            <br>
            <button type="button" class="text-link link-register link-mode-toggle"
                    @click="changeMode('register')">{{ copydeck?.btnRegisterToggle?.fr ?? '' }}
            </button>
        </div>
    </div>

    <div v-else>

        <div class="form-intro" v-html=" message ?? '' "></div>
    </div>

</template>

<script setup>
// Vue
import { ref, reactive, computed } from 'vue';
import { useStore }                from 'vuex';
import axios                       from 'axios';

// store
let store    = useStore();
let copydeck = computed( () => store.state.copydeck );

const logoRougeNoTextSrc = new URL( '../../../../images/logo-rouge-no-text.svg', import.meta.url ).href;

let formErrors = computed( () => store.state.formErrors );

// composables
import { changeMode, clearSingleFieldErrors } from '../composables';


// components
import FormError from './FormError.vue';

let btnResendConfirmationSubmit = ref(null);

let confirmationSent           = ref( false );
let resendConfirmationEmail    = ref( null );
let message    = ref( "" );

const resendConfirmationFormData = reactive( {
    email           : '',
    recaptcha_token : '',
} );



async function resendConfirmation() {

    btnResendConfirmationSubmit.value.disabled = true;
    btnResendConfirmationSubmit.value.classList.add( 'ajaxing' );

    let url = store.state.resendConfirmation;
    let response = await axios.get(url);

    confirmationSent.value = true;

    if (!response.data.success) //this should never happen
    {
        message.value = response.data.message;
    }
    else
    {
        message.value = response.data.message;
    }


    btnResendConfirmationSubmit.value.disabled = false;
    btnResendConfirmationSubmit.value.classList.remove( 'ajaxing' );


}
</script>

<style scoped>

</style>
